import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, CreditCard, Settings as SettingsIcon, LogOut, Store, Tag, FileText } from 'lucide-react';
import { cn } from '../../lib/utils';
const NAV_ITEMS = [{
  label: 'Dashboard',
  href: '/',
  icon: LayoutDashboard
}, {
  label: 'Transactions',
  href: '/transactions',
  icon: FileText
}, {
  label: 'Offers',
  href: '/offers',
  icon: Tag
}, {
  label: 'Payments',
  href: '/payments',
  icon: CreditCard
}, {
  label: 'Settings',
  href: '/settings',
  icon: SettingsIcon
}, {
  label: 'Onboarding',
  href: '/onboarding',
  icon: Store
}];
export function Sidebar() {
  const location = useLocation();
  return <div className="h-full w-64 bg-slate-900 text-white flex flex-col" data-id="element-61">
      <div className="p-6" data-id="element-62">
        <div className="flex items-center gap-2 mb-8" data-id="element-63">
          <div className="h-8 w-8 bg-[#218080] rounded-lg flex items-center justify-center" data-id="element-64">
            <span className="font-bold text-lg" data-id="element-65">K</span>
          </div>
          <span className="font-bold text-xl" data-id="element-66">Kithward</span>
        </div>

        <nav className="space-y-1" data-id="element-67">
          {NAV_ITEMS.map(item => {
          const isActive = location.pathname === item.href;
          return <Link key={item.href} to={item.href} className={cn('flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors', isActive ? 'bg-[#218080] text-white' : 'text-slate-400 hover:text-white hover:bg-slate-800')} data-id="element-68">
                <item.icon className="h-5 w-5" data-id="element-69" />
                {item.label}
              </Link>;
        })}
        </nav>
      </div>

      <div className="mt-auto p-6 border-t border-slate-800" data-id="element-70">
        <button className="flex items-center gap-2 text-slate-400 hover:text-white text-sm font-medium w-full transition-colors" data-id="element-71">
          <LogOut className="h-4 w-4" data-id="element-72" />
          Sign Out
        </button>
      </div>
    </div>;
}